"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToDocument = (html) => {
    const doc = window.document.implementation.createHTMLDocument('');
    doc.open();
    doc.write(html);
    doc.close();
    return doc;
};
//# sourceMappingURL=stringToDocument.js.map